/*!
 * Copyright (c) 2022 Digital Bazaar, Inc. All rights reserved.
 */
export const requiredAlgorithm = 'Ed25519';
